<template>
	<el-container class="student">
		<el-aside width="180px">
			<nav-menu></nav-menu>
		</el-aside>
		<el-main class="content">
			<el-row :gutter="0">
				<el-col :span="4">
					<el-card class="tree-box">
						<el-scrollbar style="height:100%">
							<el-tree :data="data" :props="defaultProps" @node-click="handleNodeClick" :default-expand-all="true"></el-tree>
						</el-scrollbar>
					</el-card>
				</el-col>
				<el-col :span="20">
					<div class="box">
						<el-card class="screen-box">
							<el-form ref="form" :model="searchForm" :inline="true" size="small">
								<el-form-item label="学生姓名:">
									<el-input placeholder="请输入学生姓名" v-model="searchForm.nick"></el-input>
								</el-form-item>
								<el-form-item label="学号:">
									<el-input placeholder="请输入学号" v-model="searchForm.studentNo"></el-input>
								</el-form-item>
								<el-form-item>
									<el-button @click="search()" icon="el-icon-search" type="primary" size="small">查询</el-button>
									<el-button @click="resetForm()" icon="el-icon-delete" size="small">清空</el-button>
									<el-popconfirm title="您确定要同步吗？" @confirm="synchronous()">
										<el-button slot="reference" icon="el-icon-refresh" style="margin-left:10px;" type="primary" size="small">同步</el-button>
									</el-popconfirm>
								</el-form-item>
							</el-form>
						</el-card>
						<el-card class="table-box">
							<el-table :data="tableList" id="table" border>
								<el-table-column type="index" width="50"></el-table-column>
								<template v-for="(item, index) in tableLabel">
									<el-table-column :key="index" :prop="item.prop" :label="item.label"
										:formatter="item.formatter">
									</el-table-column>
								</template>
							</el-table>
							<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchForm.page" :page-sizes="pageSizes" :page-size="searchForm.limit" layout="total, sizes, prev, pager, next, jumper" :total="totalCount"></el-pagination>
						</el-card>
					</div>
				</el-col>
			</el-row>
		</el-main>
	</el-container>
</template>

<script>
	import { classTreeApi,hikStudentPageApi,hikStudentSyncApi } from "@/axios/api";
	export default {
		name: "Studenthik",
		data() {
			return {
				totalCount:0,
				pageSizes:[10],
				searchForm: {
					hikClassIds:[],//班级id
					nick:'',//	学生名称
					studentNo:'',//学生编号
					isSearchCount:true,
					limit:10,
					page:1
				},
				tableList: [],
				tableLabel: [{
					label: "学生姓名",
					prop: "studentName"
				}, {
					label: "班级",
					prop: "className"
				}, {
					label: "学号",
					prop: "studentNumber"
				}, {
					label: "学生卡",
					prop: "card"
				}, {
					label: "手机号",
					prop: "phoneNumber"
				}, {
					label: "性别",
					prop: "studentSex",
					formatter: (row) => {
						return row.studentSex == 1 ? '男' : '女';
					}
				}, {
					label: "学生类型",
					prop: "studentType",
					formatter: (row) => {
						return row.studentType == 1 ? '住校生' : '走读生';
					}
				}, {
					label: "入学日期",
					prop: "entryDate"
				}, {
					label: "毕业日期",
					prop: "graduateDate"
				}, {
					label: "账号有效时间",
					prop: "accountExpired"
				}],
				data: [],
				defaultProps: {
					children: 'children',
					label: 'label'
				}
			}
		},
		created(){
			this.getData();
			classTreeApi({}).then((res) => {
				if (res.code == 200){
					this.data = res.data;
				}
			}).catch((err) => {});
		},
		methods: {
			getData(){
				hikStudentPageApi(this.searchForm).then((res) => {
					if (res.code == 200){
						this.tableList = res.data.records;
						this.totalCount = res.data.total;
					}
				}).catch((err) => {});
			},
			//查询
			search(){
				this.searchForm.page = 1;
				this.getData();
			},
			//清空
			resetForm(){
				this.searchForm = {
					hikClassIds:[],
					nick:'',
					studentNo:'',
					isSearchCount:true,
					limit:10,
					page:1
				}
				this.getData();
			},
			//同步
			synchronous(){
				hikStudentSyncApi({}).then((res) => {
					if (res.code == 200){
						this.$message.success("同步成功");
						this.getData();
					}
				}).catch((err) => {});
			},
			//树
		    handleNodeClick(data,node) {
		        node.expanded = true
		        this.searchForm.hikClassIds = data.childrenIds.join(',');
		        this.searchForm.page=1;
		        this.getData();
		    },
			// 分页
			handleSizeChange(val) {
				this.searchForm.limit=val // 改变每页显示的条数 
				this.searchForm.page=1 // 注意：在改变每页显示的条数时，要将页码显示到第一页
				this.getData() // 点击每页显示的条数时，显示第一页
			},
			handleCurrentChange(val) {
				this.searchForm.page=val // 改变默认的页数
				this.getData() // 切换页码时，要获取每页显示的条数
			}
		}
	}
</script>

<style lang="less" scoped>
	/deep/.tree-box .is-horizontal{
		display: none;
	}
	/deep/.tree-box .el-scrollbar__wrap {
		overflow-x: hidden;
	}
	/deep/.tree-box .el-tree{
		border: 1px solid #EBEEF5;
		padding: 15px 0;
	}
</style>